<template>
    <div :id="id" class="numeric_input" >
        <span class="symbol-label" v-bind:class="{validator:show_validation && isNaN(value)}">{{label}}</span>
        <div class="number-input-wrap" :class="InputWrapClass" >
            <input ref="inputfield" :placeholder="label" type="number" min="0" :value="value"  @input="setNum" class="form-control"
            @mouseenter="disableDrag" @mouseleave="enableDrag"
            />
            <div class="number-nav">
                <div class="number-button number-up" @click.stop="inc()">&and;</div>
                <div class="number-button number-down" @click.stop="dec();">&or;</div>
            </div>

        </div>
        <div :style="ValidatorClass">
            <span class="validator"
                  v-if="show_validation && isNaN(num)">Invalid format</span>
            <span class="validator"
                  v-if="show_validation && num<0">{{label}} Out of Range</span>
            <span class="validator" v-if="show_validation && num===''">{{label}} cannot be blank</span>
        </div>
    </div>

</template>

<script >

    import Component from 'vue-class-component'
    import {Prop, Watch, Vue, Emit} from 'vue-property-decorator'
    import {EventBus,Messages} from '../../services/EventBus';

    export default Vue.extend ({
      props:{
          value: {type:Number,required:true},
          label:{type:String,required:true},
          id:{type:String,required:true},
          InputWrapClass: {type:String, required:false, default:""},
          ValidatorClass: {type:String, required:false, default:""},
          focus:{type:Boolean, required:false,default:false},
          show_validation: {type:Boolean, required: true}
      } , methods: {
          disableDrag(){
              EventBus.$emit(Messages.DragPlaceWindowDisable)
          },
          enableDrag(){
              EventBus.$emit(Messages.DragPlaceWindowEnable)
          },
          setNum(ev) {
              let v = parseInt(ev.target.value);
              if (v>=0){
                  this.num= v;
                  this.$emit('input',parseInt(v));
              } else {
                  this.num= "";
                  this.$emit('input',NaN);
              }
          },
            inc(){
                this.$emit('input',this.value+1);
            },
            dec(){
                this.value>0? this.$emit('input',this.value-1) : null;
            }
        },
        data(){
          return {
              num: 0
          }
        },
        mounted:()=>{

        }
//          focus:{
//              get(){
//                  return this.focus;
//              },
//              set(){
//                  this.$emit('focus')
//              }
//          }
//        }
    })
</script>

<style scoped>
    .numeric_input {
        padding: 5px;
    }

    .numeric_input input:invalid{

    }
</style>